"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDevice = void 0;
const browser_1 = require("./adapters/browser");
const lg_1 = require("./adapters/lg");
const samsung_1 = require("./adapters/samsung");
let _device;
function getDevice(adapter) {
    return __awaiter(this, void 0, void 0, function* () {
        if (_device) {
            return Promise.resolve(_device);
        }
        const _adapter = adapter ||
            [(0, lg_1.getLGTVAdapter)(), (0, samsung_1.getSamsungAdapter)()].find((adapter) => !!adapter);
        const device = yield (_adapter ? _adapter() : (0, browser_1.getBrowserDevice)());
        _device = device;
        return device;
    });
}
exports.getDevice = getDevice;
//# sourceMappingURL=index.js.map